import React from 'react'
import { connect } from 'react-redux'
// import productLogo from '../../../../public/resources/images/products/vv-logo.png'
import { broadcastContentEnums } from 'enums/broadcastContent'
import style from './style.module.scss'

const mapStateToProps = ({ settings }) => ({ settings })

const Footer = () => {
  const version = process.env.REACT_APP_VERSION
  return (
    <div className={style.footer}>
      <div className={style.footerInner}>
        <a
          href="https://Virtuevise.com"
          target="_blank"
          rel="noopener noreferrer"
          className={style.logo}
        >
          <div className={style.logo}>
            {/* <img src={productLogo} width="100" height="auto" alt={`logo-${productLogo}`} /> */}
            <h2
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontSize: '28px',
                fontWeight: 600,
              }}
            >
              Value <span style={{ color: '#f1a400', fontWeight: 700 }}>Portal</span> {version}
            </h2>
          </div>
        </a>
        <br />
        <p className="mb-0">
          Copyright © {new Date().getFullYear()}{' '}
          <a href="https://Virtuevise.com" target="_blank" rel="noopener noreferrer">
            Virtuevise.com
          </a>
          {' | '}
          <a href="https://Virtuevise.com/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          {' | '}
          <a href={broadcastContentEnums?.TRACKER_LINK} target="_blank" rel="noopener noreferrer">
            Download Tracker
          </a>
        </p>
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(Footer)
